import React from "react";
import styled from "styled-components";
import GlobalSizeStyled from '../../styles/global_size.scss';
import VideoMonsterHero from "./VideoMonsterHero";
import TemplateToVideoSection from "./TemplateToVideoSection";
import FeatureDescription from "./FeatureDescription";
import StatisticsSection from "./StatisticsSection";
import TestimonialSection from "./TestimonialSection";
import UrlToVideoSection from "./UrlToVideoSection";
import AiToolsSection from "./AiToolsSection";
import AiStudioSection from "./AiStudioSection";
import GenStudio from "./GenStudio";
import PriceSection from "./PriceSection";
import HeroContent from "./VideomonsterHeroContent";

const NewLanding2025Container = styled.main`
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;
  justify-content: start;
  margin-top: ${GlobalSizeStyled.DEFAULT_TOP_BAR_HEIGHT};
`;

const WhiteArea = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
`;

export default function NewLanding2025({ onThumbnailClicked, value, history }) {
  return (
    <NewLanding2025Container>
      <VideoMonsterHero history={history} />
      <PriceSection history={history} />
      <TemplateToVideoSection onThumbnailClicked={onThumbnailClicked} lang={value} history={history} />
      <UrlToVideoSection history={history} />
      <AiStudioSection history={history} />
      <AiToolsSection history={history} />
      <HeroContent history={history} />
      <FeatureDescription history={history} />
      <StatisticsSection history={history} />
      <TestimonialSection history={history} />
      <GenStudio history={history} />
    </NewLanding2025Container>
  );
}
